import { FC } from 'react'

const MobileBlockerIcon: FC = () => (
  <svg
    width="100"
    height="100"
    viewBox="0 0 100 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z"
      fill="url(#paint0_linear_31463_396968)"
    />
    <g filter="url(#filter0_dd_31463_396968)">
      <circle
        cx="50"
        cy="50"
        r="32"
        fill="white"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.0625 45.5938C52.0625 46.8882 53.1118 47.9375 54.4062 47.9375C55.7007 47.9375 56.75 46.8882 56.75 45.5938C56.75 44.2993 55.7007 43.25 54.4062 43.25C53.1118 43.25 52.0625 44.2993 52.0625 45.5938ZM53.625 45.5938C53.625 46.0252 53.9748 46.375 54.4062 46.375C54.8377 46.375 55.1875 46.0252 55.1875 45.5938C55.1875 45.1623 54.8377 44.8125 54.4062 44.8125C53.9748 44.8125 53.625 45.1623 53.625 45.5938Z"
      fill="#054C2E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M44.25 53.4062C44.25 54.7007 45.2993 55.75 46.5938 55.75C47.8882 55.75 48.9375 54.7007 48.9375 53.4062C48.9375 52.1118 47.8882 51.0625 46.5938 51.0625C45.2993 51.0625 44.25 52.1118 44.25 53.4062ZM45.8125 53.4062C45.8125 53.8377 46.1623 54.1875 46.5938 54.1875C47.0252 54.1875 47.375 53.8377 47.375 53.4062C47.375 52.9748 47.0252 52.625 46.5938 52.625C46.1623 52.625 45.8125 52.9748 45.8125 53.4062Z"
      fill="#054C2E"
    />
    <rect
      x="45.8125"
      y="44.8125"
      width="7.8125"
      height="1.5625"
      rx="0.5"
      fill="#054C2E"
    />
    <rect
      x="47.375"
      y="52.625"
      width="7.8125"
      height="1.5625"
      rx="0.5"
      fill="#054C2E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.125 62H59.875C61.6009 62 63 60.6009 63 58.875V40.125C63 38.3991 61.6009 37 59.875 37H41.125C39.3991 37 38 38.3991 38 40.125V58.875C38 60.6009 39.3991 62 41.125 62ZM61.4375 58.875C61.4375 59.7379 60.7379 60.4375 59.875 60.4375H41.125C40.2621 60.4375 39.5625 59.7379 39.5625 58.875V40.125C39.5625 39.2621 40.2621 38.5625 41.125 38.5625H59.875C60.7379 38.5625 61.4375 39.2621 61.4375 40.125V58.875Z"
      fill="#054C2E"
    />
    <defs>
      <filter
        id="filter0_dd_31463_396968"
        x="8"
        y="8"
        width="84"
        height="84"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood
          floodOpacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.7625 0 0 0 0 0.7625 0 0 0 0 0.7625 0 0 0 0.12 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_31463_396968"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="5" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_31463_396968"
          result="effect2_dropShadow_31463_396968"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_31463_396968"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_31463_396968"
        x1="50"
        y1="0"
        x2="50"
        y2="100"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          stopColor="#B1F946"
          stopOpacity="0.19"
        />
        <stop
          offset="1"
          stopColor="#B1F946"
          stopOpacity="0.39"
        />
      </linearGradient>
    </defs>
  </svg>
)

export default MobileBlockerIcon
